import { Component, ViewChild } from '@angular/core';
import { Nav, Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
//import { Device } from '@ionic-native/device';

import { HomePage } from '../pages/home/home';
import { ListPage } from '../pages/list/list';

import { StorageProvider } from '../providers/storage/storage';
import { UserProvider } from '../providers/user/user';

import { AlertController } from 'ionic-angular';



interface deviceInterface {
  id?: string,
  model?: string,
  cordova?: string,
  platform?: string,
  version?: string,
  manufacturer?: string,
  serial?: string,
  isVirtual?: boolean,

};

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  rootPage: any = HomePage;

  pages: Array<{ title: string, component: any }>;
  public deviceInfo: deviceInterface = {};

  constructor(
    public platform: Platform,
    public statusBar: StatusBar,
    public splashScreen: SplashScreen,
    //private device: Device,
    private storageProvider: StorageProvider,
    private userProvider: UserProvider,
    private alertCtrl: AlertController) {

    this.initializeApp();

    console.log(this.deviceInfo);

    // used for an example of ngFor and navigation
    this.pages = [
      { title: 'Home', component: HomePage },
      { title: 'List', component: ListPage }
    ];

  }


  initializeApp() {
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      let ion = this;

      this.storageProvider.get('overAge').then(resage => {
        //console.log("pa ve la edad", resage);
        if (resage === null) {
          this.presentAlertCondition().then(resalert => {
            this.chooseGender().then(gender => {
              this.doRadioPreference().then(prefference => {
                //console.log("WTF")
                //console.log("Preference", prefference)
                //console.log("Gender", gender)
                ion.getInfo();
                //console.log("DEVICE", this.deviceInfo)
                if (prefference != null && this.deviceInfo.id) {
                  //console.log("GUARDANDO", this.deviceInfo)
                  ion.userProvider.postUserDevice(ion.deviceInfo.id, prefference, gender);
                  //console.log("estoy guardando el device id en storage", ion.deviceInfo.id)
                  ion.storageProvider.set('deviceId', ion.deviceInfo.id);
                  //console.log(resalert);
                  //AQUI , SI ES PRIMERA VEZ, DEBERIA LLAMAR AL HOME PAGE CON LAS HISTORIAS POPULARES O LAS QUE ME INTERESAN (AUG)
                }
              }).catch(error => {
                console.log("error 1", error);
              });
            }).catch(error => {
              console.log("error 2", error);
            });
          }).catch(error => {
            console.log("error 3", error);
          });
        }
      })

      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
  }

  openPage(page) {
    // Reset the content nav to have just this page
    // we wouldn't want the back button to show in this scenario
    if (page.title == 'Cover') {
      this.nav.push(page.component, { story_id: "8Uw3VhuTC2NtEtAbDE3L" });
    } else {
      this.nav.setRoot(page.component);
    }
  }

  getInfo() {
    this.deviceInfo.id = this.makeid();
    //  this.deviceInfo.model = this.device.model;
    //  this.deviceInfo.cordova = this.device.cordova;
    //  this.deviceInfo.platform = this.device.platform;
    //   this.deviceInfo.version = this.device.version;
    //    this.deviceInfo.manufacturer = this.device.manufacturer;
    //  this.deviceInfo.serial = this.device.serial;
    //  this.deviceInfo.isVirtual = this.device.isVirtual;
  }

  makeid() {
    var text = "";
    var possible = "abcdefghijklmnopqrstuvwxyz0123456789";

    for (var i = 0; i < 16; i++)
      text += possible.charAt(Math.floor(Math.random() * possible.length));

    return text;
  }


  presentAlertCondition() {
    return new Promise((Resolve, Reject) => {
      let alert = this.alertCtrl.create({
        enableBackdropDismiss: false,
        cssClass: 'alertCustomCss1',
        title: 'Esta aplicación es para mayores de 18 años.',
        message: "<span style='text-align: justify;'>Al darle 'Soy mayor de 18 años', Tú estás de acuerdo con nuestros <a href='https://www.w3schools.com'>terminos</a> y lo has leido.</span>",
        buttons: [
          {
            text: 'Soy mayor de 18 años',
            handler: () => {
              console.log('TERMINOS ACEPTADOS');
              Resolve(true)

            }
          }]
      });
      alert.present();
    })
  }

  chooseGender() {
    let ion = this;
    return new Promise((Resolve, Reject) => {
      let alert = this.alertCtrl.create({
        enableBackdropDismiss: false,
        cssClass: 'alertCustomCss1'
      });
      alert.setTitle('¿Indicanos Tu género?');
      alert.addInput({ type: 'radio', label: 'Masculino', value: 'M', checked: true });
      alert.addInput({ type: 'radio', label: 'Femenino', value: 'F' });
      alert.addButton({
        text: 'Aceptar',
        handler: data => {
          console.log("GENERO DEL USUARIO", data);
          ion.storageProvider.set('Genger', data);
          Resolve(data);
          // this.doRadioPreference().then(resage => {
          // });
        }
      });

      alert.present();
    })
  }

  doRadioPreference() {
    let ion = this;
    return new Promise((Resolve, Reject) => {
      let alert = this.alertCtrl.create({
        enableBackdropDismiss: false,
        cssClass: 'alertCustomCss1'
      });
      alert.setTitle('¿Cuál es tu preferencia?');
      alert.addInput({ type: 'radio', label: 'Heterosexual', value: 'Heterosexual', checked: true });
      alert.addInput({ type: 'radio', label: 'Homosexual', value: 'Homosexual' });
      alert.addInput({ type: 'radio', label: 'Bisexual', value: 'Bisexual' });
      alert.addButton({
        text: 'OK',
        handler: data => {
          console.log("PREFERENCIA DEL USUARIO", data);
          ion.storageProvider.set('overAge', '18');
          ion.storageProvider.set('Preference', data);
          Resolve(data);
        }
      });

      alert.present();
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts